import { PropsWithChildren, createContext, useContext, useState, useCallback } from "react";
import { UserSession } from "../types";
import { AuthService } from "../services/AuthService";

interface UserContextType {
  userSession: UserSession | null;
  setUserSession: React.Dispatch<React.SetStateAction<UserSession | null>>;
  logoutUser: () => void;
}

export const UserContext = createContext<UserContextType>({} as UserContextType);

export const useUserSessionContext = () => useContext(UserContext);

export const UserSessionContextWrapper = ({ children }: PropsWithChildren) => {
  const [userSession, setUserSession] = useState<UserSession | null>(null);

  const logoutUser = useCallback(() => {
    setUserSession(null);
    AuthService.unsetRefreshTokenCookie();
  }, []);

  return <UserContext.Provider value={{ userSession, setUserSession, logoutUser }}>{children}</UserContext.Provider>;
};
